import SingleFormCard from '../SingleFormCard';
import styled from 'styled-components';
import { isfCard as isfCardStyles } from '@xbcb/ui-styles';

const IsfCard = styled(SingleFormCard)`
  ${isfCardStyles}
`;

export default IsfCard;
